import React, { useState } from 'react';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function PricingSection() {
  const [selectedOffer, setSelectedOffer] = useState<'basic' | 'elite'>('elite');
  const handleCheckout = () => {
    if (selectedOffer === 'basic') {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44041838985313:1';
    } else {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44041840099425:1';
    }
  };
  return <section className="py-6 md:py-20 bg-slate-900" id="pricing" data-id="element-238">
      <div className="max-w-3xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-239">
        <FadeIn data-id="element-240">
          <div className="text-center mb-4 md:mb-12" data-id="element-241">
            <h2 className="text-2xl md:text-5xl font-display font-black text-white mb-1 md:mb-4" data-id="element-242">
              Elegí tu Aquagym Resuelto
            </h2>
            <p className="text-sm md:text-xl text-slate-400 font-medium" data-id="element-243">
              Las dos opciones incluyen los 6 bonos estratégicos completos
            </p>
          </div>
        </FadeIn>

        <div className="flex flex-col gap-2.5 md:gap-5 mb-4 md:mb-8" data-id="element-244">
          {/* BASIC PACK */}
          <FadeIn delay={0.1} data-id="element-245">
            <div onClick={() => setSelectedOffer('basic')} className={`relative w-full rounded-xl md:rounded-2xl border-2 p-3 md:p-6 cursor-pointer transition-all duration-200 ${selectedOffer === 'basic' ? 'border-aqua-500 bg-slate-800 shadow-[0_0_20px_rgba(6,182,212,0.15)]' : 'border-slate-700/50 bg-slate-800/40 hover:border-slate-600 hover:bg-slate-800/60'}`} data-id="element-246">
              <div className="flex items-center gap-3 md:gap-6" data-id="element-247">
                {/* Radio */}
                <div className="flex-shrink-0" data-id="element-248">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedOffer === 'basic' ? 'border-aqua-500' : 'border-slate-600'}`} data-id="element-249">
                    {selectedOffer === 'basic' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-aqua-500" data-id="element-250" />}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-grow flex flex-row items-center justify-between gap-2" data-id="element-251">
                  <div className="flex flex-col gap-0.5" data-id="element-252">
                    <h3 className="text-white font-display font-black text-sm md:text-xl flex items-center gap-1.5" data-id="element-253">
                      📘 AQUAGYM RESUELTO
                    </h3>
                    <p className="text-slate-400 text-xs md:text-sm" data-id="element-254">
                      6 Tomos + 6 Bonos
                    </p>
                  </div>
                  <div className="flex flex-col items-end gap-0" data-id="element-255">
                    <span className="text-slate-500 line-through text-xs md:text-sm font-medium" data-id="element-256">
                      $34.990
                    </span>
                    <span className={`text-2xl md:text-4xl font-display font-black ${selectedOffer === 'basic' ? 'text-white' : 'text-slate-300'}`} data-id="element-257">
                      $19.990
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* ELITE PACK */}
          <FadeIn delay={0.2} data-id="element-258">
            <div onClick={() => setSelectedOffer('elite')} className={`relative w-full rounded-xl md:rounded-2xl border-2 p-3 md:p-6 cursor-pointer transition-all duration-200 ${selectedOffer === 'elite' ? 'border-aqua-500 bg-slate-800 shadow-[0_0_20px_rgba(6,182,212,0.15)]' : 'border-slate-700/50 bg-slate-800/40 hover:border-slate-600 hover:bg-slate-800/60'}`} data-id="element-259">
              <div className="flex items-start gap-3 md:gap-6" data-id="element-260">
                {/* Radio */}
                <div className="flex-shrink-0 mt-0.5" data-id="element-261">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedOffer === 'elite' ? 'border-aqua-500' : 'border-slate-600'}`} data-id="element-262">
                    {selectedOffer === 'elite' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-aqua-500" data-id="element-263" />}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-grow flex flex-row items-start justify-between gap-2" data-id="element-264">
                  <div className="flex flex-col gap-1" data-id="element-265">
                    <h3 className="text-white font-display font-black text-sm md:text-xl leading-tight" data-id="element-266">
                      🏆 PACK ÉLITE™
                    </h3>
                    <div className="flex flex-wrap items-center gap-1 md:gap-2" data-id="element-267">
                      <span className="bg-aqua-500 text-white text-[10px] md:text-xs font-bold px-1.5 py-0.5 md:px-2.5 md:py-1 rounded flex items-center gap-0.5" data-id="element-268">
                        ⭐ MÁS ELEGIDO
                      </span>
                      <span className="border border-aqua-400/50 text-aqua-400 text-[10px] md:text-xs font-bold px-1.5 py-0.5 md:px-2.5 md:py-1 rounded" data-id="element-269">
                        AHORRÁS $16.000
                      </span>
                    </div>
                    <p className="text-slate-400 text-[11px] md:text-sm leading-snug mt-0.5" data-id="element-270">
                      6 Tomos + 6 Bonos + HIIT Funcional + Programa 90 Días
                    </p>
                  </div>
                  <div className="flex flex-col items-end gap-0 flex-shrink-0" data-id="element-271">
                    <span className="text-slate-500 line-through text-xs md:text-sm font-medium" data-id="element-272">
                      $43.990
                    </span>
                    <span className={`text-2xl md:text-4xl font-display font-black ${selectedOffer === 'elite' ? 'text-aqua-400' : 'text-slate-300'}`} data-id="element-273">
                      $27.990
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* CTA Section */}
        <FadeIn delay={0.3} data-id="element-274">
          <div className="max-w-2xl mx-auto" data-id="element-275">
            <motion.button onClick={handleCheckout} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-aqua-600 hover:bg-aqua-500 text-white font-display font-black text-base md:text-2xl py-3.5 md:py-5 rounded-xl shadow-lg shadow-aqua-600/20 transition-all" data-id="element-276">
              SÍ, QUIERO MI AQUAGYM RESUELTO →
            </motion.button>
            <p className="text-center text-xs md:text-sm text-slate-400 mt-2 md:mt-4 font-medium italic" data-id="element-277">
              La opción más elegida por instructores de aquagym
            </p>
          </div>

          {/* Trust Badges */}
          <div className="mt-4 md:mt-10 border border-slate-700/50 bg-slate-800/30 rounded-xl md:rounded-2xl p-3 md:p-5" data-id="element-278">
            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-8 text-[11px] md:text-sm font-medium text-slate-300" data-id="element-279">
              <div className="flex items-center gap-1.5" data-id="element-280">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-281" />
                <span data-id="element-282">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-283">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-400" data-id="element-284" />
                <span data-id="element-285">Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-286">
                <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-aqua-400" data-id="element-287" />
                <span data-id="element-288">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-289">
                <svg className="w-3.5 h-3.5 md:w-4 md:h-4 text-blue-400" viewBox="0 0 24 24" fill="currentColor" data-id="element-290">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 21.6c-5.302 0-9.6-4.298-9.6-9.6S6.698 2.4 12 2.4s9.6 4.298 9.6 9.6-4.298 9.6-9.6 9.6zm4.8-13.2l-6 6-2.4-2.4-1.2 1.2 3.6 3.6 7.2-7.2-1.2-1.2z" data-id="element-291" />
                </svg>
                <span data-id="element-292">Mercado Pago</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}